import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import appDe from '@/app/i18n/de.json';
import authDe from '@/features/auth/i18n/de.json';
import onboardingDe from '@/features/onboarding/i18n/de.json';
import dashboardDe from '@/features/dashboard/i18n/de.json';
import accountDe from '@/features/account/i18n/de.json';
import legalDe from '@/features/legal/i18n/de.json';
import shellDe from '@/features/shell/i18n/de.json';
import auftrageDe from '@/features/auftraege/i18n/de.json';
import auftragsanlageDe from '@/features/auftragsanlage/i18n/de.json';
import supportDashboardDe from '@/features/support-dashboard/i18n/de.json';
import customersDe from '@/features/customers/i18n/de.json';
import laboreDe from '@/features/labore/i18n/de.json';
import benutzerStatusDe from '@/shared/i18n/benutzerStatus/de.json';
import bundeslandDe from '@/shared/i18n/bundesland/de.json';
import organizationStateDe from '@/shared/i18n/organizationState/de.json';
import organizationTypeDe from '@/shared/i18n/organizationType/de.json';
import roleDe from '@/shared/i18n/role/de.json';
import benutzerDe from '@/features/benutzer/i18n/de.json';
import organisationDe from '@/features/organisation/i18n/de.json';
import logistikDe from '@/features/logistik/i18n/de.json';
import dateiablageDe from '@/features/dateiablage/i18n/de.json';
import laborprofilDe from '@/features/laborprofil/i18n/de.json';

/** Initializes i18next with the German-only namespace resources bundled per feature. */
void i18n.use(initReactI18next).init({
  lng: 'de',
  fallbackLng: 'de',
  ns: [
    'app',
    'auth',
    'onboarding',
    'dashboard',
    'account',
    'legal',
    'shell',
    'auftraege',
    'auftragsanlage',
    'support-dashboard',
    'customers',
    'labore',
    'benutzerStatus',
    'bundesland',
    'organizationState',
    'organizationType',
    'role',
    'benutzer',
    'organisation',
    'logistik',
    'dateiablage',
    'laborprofil',
  ],
  defaultNS: 'app',
  resources: {
    de: {
      app: appDe,
      auth: authDe,
      onboarding: onboardingDe,
      dashboard: dashboardDe,
      account: accountDe,
      legal: legalDe,
      shell: shellDe,
      auftraege: auftrageDe,
      auftragsanlage: auftragsanlageDe,
      'support-dashboard': supportDashboardDe,
      customers: customersDe,
      labore: laboreDe,
      benutzerStatus: benutzerStatusDe,
      bundesland: bundeslandDe,
      organizationState: organizationStateDe,
      organizationType: organizationTypeDe,
      role: roleDe,
      benutzer: benutzerDe,
      organisation: organisationDe,
      logistik: logistikDe,
      dateiablage: dateiablageDe,
      laborprofil: laborprofilDe,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
